<template>
    <el-dialog title="公司架构维护" :visible="visible" :show="show" width="50%" :close-on-click-modal="false"
               @close="close" custom-class="module-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
            <!--<el-form-item label="上级部门名称" class="input" prop="companySupName" >
                <el-input v-model="ruleForm.companySupName" autocomplete="off" readonly />
            </el-form-item>-->
            <el-form-item :label="this.rowData.companyType=='1'?'公司名称':'部门名称'" class="input" prop="name" >
                <el-input v-model="ruleForm.name" autocomplete="off" placeholder="请输入....." />
            </el-form-item>
            <!--<el-form-item label="部门代码" class="input" prop="companyCode" >
                <el-input v-model="ruleForm.companyCode" autocomplete="off" placeholder="请输入部门代码" />
            </el-form-item>
            <el-form-item label="部门类型" class="input" prop="companyType" >
                <el-select v-model="ruleForm.companyType" style="width: 100%">
                    <el-option v-for="(item,i) in companyTypeList" :label="item.indexName" :key="i" :value="item.codeIndex+''"></el-option>
                </el-select>
            </el-form-item>-->
            <el-form-item label="描述" class="input" prop="companyDesc" >
                <textarea v-model="ruleForm.companyDesc" autocomplete="off" style="width:80%" rows="5"></textarea>
            </el-form-item>

            <!--<el-form-item label="代理站点" class="input" prop="zdList" v-if="this.ruleForm.companyType=='1'">
                <el-select v-model="zdListArr" multiple style="width:90%;margin-left:8%" filterable>
                    <el-option v-for="(item,i) in zdList" :key="i" :label="item.orgName" :value="item.orgId+''"></el-option>
                </el-select>
            </el-form-item>-->

            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" v-show="updateBtn" @click="commit()">保存</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'addOrUpdate',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    this.initcompanyTypeList();
                    this.getZdList();
                }
            },
            rowData(){
                if (this.show){
                    if(this.rowData.type=='edit'){
                        this.ruleForm = this.rowData;
                        if (this.rowData.companyType=='1'){
                            let arr = [];
                            if (this.rowData.zdList!=''){
                                this.zdListArr = this.rowData.zdList.split(",");
                            }

                            this.$forceUpdate();
                        }else{
                            this.zdListArr = [];
                        }
                    }else{
                        this.ruleForm.companySupId = this.rowData.id;
                        this.ruleForm.companySupName = this.rowData.name;
                        this.ruleForm.companyPathname = this.rowData.companyPathname;
                        this.ruleForm.path = this.rowData.path;
                        this.ruleForm.code = this.rowData.code;
                        this.ruleForm.name = '';
                        this.ruleForm.companyCode = '';
                        this.ruleForm.companyType = this.rowData.companyType;
                        this.ruleForm.companyDesc = '';
                        this.ruleForm.id = '';
                    }
                }
            },
            /*"ruleForm.zdListArr"(){
                alert(2222);
            }*/
        },
        data(){
            return{
                updateBtn:true,
                url:base.get().url,
                visible:false,
                ruleForm:{
                    companySupName:'',
                    name:'',
                    companyCode:'',
                    companyType:'',
                    companyDesc:'',
                },
                rules:{
                    companyName:[{ required: true, message: '请输入部门名称', trigger: 'blur' }],
                    companyType:[{ required: true, message: '请选择部门类型', trigger: 'blur' }],
                    companyCode:[{ required: true, message: '请输入部门代码', trigger: 'blur' }],
                },
                companyTypeList:[],
                zdList:[],
                zdListArr:[],
            }
        },
        methods:{
            close(){
                this.updateBtn = true;
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
            },
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        /*if (this.ruleForm.companyType=='1'){
                            this.ruleForm.zdList = this.zdListArr.join(",");
                        }*/
                        this.$http({
                            url:  this.ruleForm.id==''|| this.ruleForm.id==undefined?this.url+`company/`+"save":this.url+`company/`+"update",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: "保存成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },
            initcompanyTypeList(){
                let params = {
                    page: this.pageIndex,
                    limit: this.pageSize,
                    sort: 'id',
                }
                //本表的
                params['dicCode'] = "company_types"//编码名字
                params['dicName'] = "公司类型",//汉字名字
                this.$http({
                    url: "dictionary/page",
                    method: "get",
                    params: params
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.companyTypeList = data.data.list;
                    }
                });
            },
            getZdList(){
                let userId = this.$storage.get("userId");
                this.$http({
                    url: "/sysUserOrg/getZdListByUserId/"+userId,
                    method: "get",
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        //this.companyTypeList = data.data.list;
                        console.log(data);
                        this.zdList = data.zdList;
                    }
                });
            }

        }
    }
</script>
<style lang="scss">
    .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }

    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
    }

    .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }

    .detail-form-content .el-form-item {
        margin-bottom: 20px;
    }

    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
        font-size: 14px;
    }

    .detail-form-content .el-form-item__content {
        line-height: normal;
    }

    .detail-form-content .el-input__inner {
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-select {
        width: 100%;
    }

    .detail-form-content .el-upload-list--picture-card .el-upload-list__item,
    .detail-form-content .el-upload--picture-card {
        width: 120px;
        height: 120px;
        line-height: 126px;
        border-radius: 6px;
        border: 1px dashed #c0ccda;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-upload--picture-card:hover {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-upload--picture-card i {
        font-size: 28px;
        color: #8c939d;
    }

    .detail-form-content .el-upload--picture-card:hover i {
        color: var(--publicMainColor);
    }

    .detail-form-content .el-input.is-disabled .el-input__inner {
        background-color: #f5f7fa;
        color: #909399;
        cursor: not-allowed;
    }

    .detail-form-content .form-footer {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding-top: 16px;
        border-top: 1px solid #f0f0f0;
        margin-top: 8px;
    }

    .detail-form-content .form-footer .el-button {
        min-width: 100px;
        border-radius: 4px;
    }

    .detail-form-content .form-footer .el-button--primary {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
    }

    .detail-form-content .form-footer .el-button--primary:hover {
        background-color: #2b5797;
        border-color: #2b5797;
    }

    .detail-form-content .form-footer .el-button--default:hover {
        color: var(--publicMainColor);
        border-color: rgba(58, 110, 165, 0.3);
        background-color: rgba(58, 110, 165, 0.06);
    }
</style>